import type Owner from '@ember/owner';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

import type { NoResultsBaseArgs } from 'webapp/components/no-results/base';
import NoResultsBaseComponent from 'webapp/components/no-results/base';

export default class BillingDatasetsComponent extends NoResultsBaseComponent<NoResultsBaseArgs> {
	@service('billing') declare billingService: Service.Billing;

	constructor(owner: Owner, args: NoResultsBaseArgs) {
		super(owner, args);

		this.trialFeature = BillingFeature.ADVANCED_DATA_SOURCES;

		this.titleText = 'Advanced analytics capabilities with custom-built datasets';
		this.descText =
			'Create and select specific properties from data sources with replicated data, enabling you to view, filter, export, and merge raw data effortlessly.';
		this.readMoreUrl = 'https://help.databox.com/understanding-datasets';
		this.topImageLightUrl = '/images/placeholders/datasets.svg';
		this.topImageDarkUrl = '/images/placeholders/datasets.svg';

		this.imageLightUrl = '/images/placeholders/placeholder-datasets.svg';
		this.imageHeight = 548;
	}

	override get mustUpgrade() {
		return !this.billingService.checkIfCan(BillingFeature.ADVANCED_DATA_SOURCES);
	}
}
